import Vue from 'vue';
import Vuetify from 'vuetify/lib';
import 'material-design-icons-iconfont/dist/material-design-icons.css' // Ensure you are using css-loader
import de from '../locales/de.ts'
import en from '../locales/en.ts'

Vue.use(Vuetify);

export default new Vuetify({
    icons: {
        iconfont: 'md'
    },
    theme: {
        themes: {
            light: {
                primary: '#014b76',
                lightBlue5: '#E3F2FD',   //#92B1DA
                hellgrau: '#F5F5F5',
                hellgreen:'#E8F5E9',
                green:'#00AA55',
            }
        }
    },
    lang: {
        locales: { de, en },
        current: 'de'
    }
})
